import React, {useState} from "react"
import {useNavigate} from "react-router-dom"
import {useQuery} from "react-query"
import {Modal} from "react-bootstrap"
import classNames from "classnames"
import nprogress from "nprogress"
import {toast} from "react-toastify"
import useAuth from "auth/useAuth"
import "./RescuerEnabled.css"


export default function UserEnabled(props) {

    const {username} = props
    const {auth, API, admin} = useAuth()
    const navigate = useNavigate()
    const {data: enabled, refetch, isLoading} = useQuery(
        ["rescuer-enabled", username],
        () => auth(API.rescuersIdEnabledGet, { 'id': username }).then(response => response.data)
    )
    const canDisableUser = admin
    const canEnableUser = admin
    const canDeleteUser = admin

    // Deceased modal state
    const [showDeceased, setShowDeceased] = useState(false)
    const [deceasedDate, setDeceasedDate] = useState('')
    const [yearOnly, setYearOnly] = useState(true)
    
    
    const disable = () => {
        if (!window.confirm("Deaktivirajte korisnika? To znači da ne može više da se uloguje i ne prikazuje se u pretragama."))
            return
        nprogress.start()
        auth(API.rescuersIdEnabledDelete, {'id': username}).then(response => {
            toast.success("Deaktiviran")
            refetch()
            nprogress.done()
        }).catch(response => {
            toast.error("Nije deaktiviran")
            nprogress.done()
        })
    }

    const enable = () => {
        nprogress.start()
        auth(API.rescuersIdEnabledPut, {'id': username}).then(response => {
            toast.success("Aktiviran")
            refetch()
            nprogress.done()
        }).catch(response => {
            toast.error("Nije aktiviran")
            nprogress.done()
        })
    }

    const deleteRescuer = () => {
        const resp = window.prompt("Ako stvarno želite da obrišete spasioca, upišite 'hoću'.\nNe postoji undelete.")
        if (resp !== 'hoću') {
            toast.error("Nije obrisan")
            return
        }

        nprogress.start()
        auth(API.rescuersIdDelete, {'id': username}).then(response => {
            toast.success("Obrisan")
            nprogress.done()
            navigate('/')
        }).catch(response => {
            toast.error("Nije obrisan")
            nprogress.done()
        })
    }

    const toggleYearOnly = () => {
        const newYearOnly = !yearOnly
        setYearOnly(newYearOnly)
        if (newYearOnly && deceasedDate) {
            // Switching to year-only: extract year from full date
            const year = deceasedDate.substring(0, 4)
            setDeceasedDate(year)
        } else if (!newYearOnly) {
            // Switching to full date: clear value
            setDeceasedDate('')
        }
    }

    const markDeceased = () => {
        let deceasedValue
        if (deceasedDate) {
            deceasedValue = deceasedDate  // year string "2024" or full date "2024-03-15"
        } else {
            deceasedValue = true  // boolean true when no date provided
        }

        nprogress.start()
        auth(API.rescuersIdPatch, {id: username}, {username, deceased: deceasedValue}).then(response => {
            toast.success("Označen kao preminuo")
            setShowDeceased(false)
            nprogress.done()
        }).catch(response => {
            toast.error("Greška pri snimanju")
            nprogress.done()
        })
    }

    const openDeceasedModal = () => {
        setDeceasedDate('')
        setYearOnly(true)
        setShowDeceased(true)
    }


    if (!admin || isLoading || enabled == null) return
    
    return <div id="user-enabled" className="subsection">
        <span className={classNames({"enabled": enabled})}>
            {enabled ? "Korisnik je aktivan" : "Korisnik nije aktivan"}
        </span>
        {enabled && canDisableUser && <button className="btn btn-danger btn-sm" onClick={disable}><i className="fa-solid fa-user-xmark"/>Disable</button>}
        {!enabled && canEnableUser && <button className="btn btn-success btn-sm" onClick={enable}><i className="fa-solid fa-user-check"/>Enable</button>}
        {!enabled && canDeleteUser && <button className="btn btn-danger btn-sm" onClick={deleteRescuer}><i className="fa-solid fa-user-slash"/>Delete</button>}
        {admin && <button className="btn btn-secondary btn-sm" onClick={openDeceasedModal}><i className="fa-solid fa-cross"/>Preminuo</button>}

        <Modal show={showDeceased} onHide={() => setShowDeceased(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Označi kao preminulog</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Opciono unesite godinu ili datum smrti:</p>
                <div className="deceased-input">
                    {yearOnly
                        ? <input type="number" value={deceasedDate} onChange={e => setDeceasedDate(e.target.value)} placeholder="GGGG" min="1900" max="2100"/>
                        : <input type="date" value={deceasedDate} onChange={e => setDeceasedDate(e.target.value)}/>
                    }
                    <label className="year-only-toggle">
                        <input type="checkbox" checked={yearOnly} onChange={toggleYearOnly}/>
                        Samo godina
                    </label>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-danger" onClick={markDeceased}>Potvrdi</button>
                <button className="btn btn-light" onClick={() => setShowDeceased(false)}>Odustani</button>
            </Modal.Footer>
        </Modal>
    </div>
}
